import api from './api';

export async function getPartnersList(params: object) {
    const response = await api
        .get(`/stores`, { params })
        .catch((err) => {
            console.error('getPartnersList', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function getDictionary() {
    const response = await api
        .get(`/dictionary`, {})
        .catch((err) => {
            console.error('getDictionary', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function getCategoriesListTree(country_id: string) {
const response = await api
        .get(`/categories/tree/${country_id}`)
        .catch((err) => {
            console.error('getCategoriesTree', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function createCategory(payload: object) {
    const response = await api
        .post(`/categories`, payload)
        .catch((err) => {
            console.error('createCategory', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function updateCategory(id: number, payload: object) {
    const response = await api
        .patch(`/categories/${id}`, payload)
        .catch((err) => {
            console.error('updateCategory', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function deleteCategory(id: number) {
    const response = await api
        .delete(`/categories/${id}`)
        .catch((err) => {
            console.error('deleteCategory', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function getProductsList(params: object) {
    const response = await api
        .get(`/products`, { params })
        .catch((err) => {
            console.error('getProductsList', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function createProduct(payload: object) {
    const response = await api
        .post(`/products`, payload)
        .catch((err) => {
            console.error('createProduct', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function updateProduct(id: string, payload: object) {
    const response = await api
        .patch(`/products/${id}`, payload)
        .catch((err) => {
            console.error('updateProduct', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}

export async function deleteProduct(id: number) {
    const response = await api
        .delete(`/products/${id}`)
        .catch((err) => {
            console.error('deleteProduct', err);
            return { status: err.response.status, data: err.response.data };
        });
    return { status: response.status, data: response.data };
}
